import { createSlice } from "@reduxjs/toolkit";


const initialState = {
    SmartDevicesData: [],       // Stores smart device data
    lastFetchedSmartDevicesData: []
};

const smartDevicesSlice = createSlice({
    name: "smartDevices",
    initialState,


    reducers: {
        setSmartDevicesCache: (state, action) => {
            const { name, data } = action.payload;
            if (name === "SmartDevicesData") {
                state.SmartDevicesData = data;
            } 
            if (name === "lastFetchedSmartDevicesData") {
                state.lastFetchedSmartDevicesData = data;
            }
        },
        clearSmartDevices: (state) => {
            state.SmartDevicesData = [];
            state.lastFetchedSmartDevicesData = [];
        },
    },
});

export const { setSmartDevicesCache, clearSmartDevices } = smartDevicesSlice.actions;
export default smartDevicesSlice.reducer;
